module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"placeholder":"Send to these phone types","contactPhoneType":"Contact phone type","types":{"mobile":"Mobile","work":"Work","home":"Home","other":"Other"},"helpText":"Phone types are managed on the contact record","errorText":"Please select phone type(s) to send to."}}')
  delete Component.options._Ctor
}
